import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import { getUser } from '../../../reducers'
import { cloudFunctions } from '../../../config/Fire'
import './newBidStyles.css'
import FormBidOrder from '../../containers/FormBidOrder'
import * as Constants from '../../../constants'
import { storage } from '../../../config/Fire'
import { generateApprovedQuotationPDF } from '../../utils/pdfUtils'

const NewBid = props => {
    const [savingBidOrder, setSavingBidOrder] = useState(false)

    const saveBidOrder = async BidOrder => {
		BidOrder.quotedEngineeringDays =
			BidOrder.quotedEngineeringDays !== undefined &&
			BidOrder.quotedEngineeringDays !== null &&
			BidOrder.quotedEngineeringDays !== '' &&
			!Number.isNaN(parseFloat(BidOrder.quotedEngineeringDays))
				? parseFloat(BidOrder.quotedEngineeringDays)
				: null
		BidOrder.predictedKilometers =
			BidOrder.predictedKilometers !== undefined &&
			BidOrder.predictedKilometers !== null &&
			BidOrder.predictedKilometers !== '' &&
			!Number.isNaN(parseInt(BidOrder.predictedKilometers, 10))
				? parseInt(BidOrder.predictedKilometers, 10)
				: null
        let month = BidOrder.startDate.month() + 1 < 10 ? `0${BidOrder.startDate.month() + 1}` : BidOrder.startDate.month() + 1
        let customDate = `${BidOrder.startDate.date()}/${month}/${BidOrder.startDate.year()}`
        BidOrder.startDate = customDate
        
        // if (BidOrder.hasTopography === undefined) BidOrder.hasTopography = false
        let categoryKey = null
        if (BidOrder.company === 'SD') categoryKey = Object.keys(Constants.categorySDBidOrderMap).find(key => Constants.categorySDBidOrderMap[key] === BidOrder.category)
        else categoryKey = Object.keys(Constants.categoryARCASABidOrderMap).find(key => Constants.categoryARCASABidOrderMap[key] === BidOrder.category)
        BidOrder.categoryKey = categoryKey
        BidOrder.year = new Date().getFullYear()

        setSavingBidOrder(true)
        try {
            const response = await cloudFunctions.getQuotationName({ category: BidOrder.category, startDate: BidOrder.startDate, categoryKey: BidOrder.categoryKey })
            if (response.data.code === 0) {
                BidOrder.quotation = response.data?.data?.quotation
                BidOrder.numeration = response.data?.data?.numeration
                BidOrder.categoryNumber = response.data?.data?.categoryNumber
                BidOrder.id = response.data?.data?.id
            } else {
                message.error('Se produjo un error al guardar la cotización. Por favor, vuelva a intentarlo')
            }
        } catch (err) {
            setSavingBidOrder(false)
            message.error('Se produjo un error al guardar la cotización. Por favor, vuelva a intentarlo')
        }
        
        let fileUrl = `bids/${BidOrder.id}/cotizacion-${BidOrder.quotation}.pdf`;
        BidOrder.fileUrl = fileUrl; // Siempre asignamos la ruta para que se guarde en la BD
        
        if (BidOrder.fileItem) {
            try {
                await storage.ref().child(fileUrl).put(BidOrder.fileItem.file.originFileObj)
            } catch (err) {
                message.error('Se produjo un error al editar la cotización. Por favor, vuelva a intentarlo')
                return
            }
        }
        
        try {
            const responseN = await cloudFunctions.newBidOrder(BidOrder)
            if (responseN.data.code === 0) {                
                // Generar PDF de cotización
                try {
                    // Construir clientData con los datos completos de los clientes
                    const clientDataArray = []
                    if (BidOrder.clients && Array.isArray(BidOrder.clients)) {
                        BidOrder.clients.forEach(clientId => {
                            const client = props.clients?.[clientId]
                            if (client) {
                                clientDataArray.push({
                                    name: client.name || '',
                                    interlocutor: client.interlocutor || ''
                                })
                            }
                        })
                    }
                    
                    // Crear una copia de bidOrder con clientData agregado
                    const bidOrderWithClientData = {
                        ...responseN.data.bidOrder,
                        clientData: clientDataArray
                    }
                    
                    // Crear un workOrder mínimo para la función (no se usa realmente, pero es requerido)
                    const workOrderMinimal = {
                        year: BidOrder.year || new Date().getFullYear(),
                        startDate: BidOrder.startDate || ''
                    }
                    
                    // Usar los items del bidOrder como selectedItems
                    const selectedItems = BidOrder.items || []
                    const userEmail = props.user?.email || ''
                    
                    const quotationDoc = await generateApprovedQuotationPDF(
                        bidOrderWithClientData, 
                        workOrderMinimal, 
                        selectedItems, 
                        '', 
                        userEmail
                    )
                    
                    // Si el usuario no subió un archivo manual, guardamos el que generamos en Storage
                    if (!BidOrder.fileItem) {
                        try {
                            const pdfBlob = quotationDoc.output('blob')
                            await storage.ref().child(fileUrl).put(pdfBlob)
                        } catch (storageErr) {
                            console.error('Error al subir PDF automático a Storage:', storageErr)
                        }
                    }
                    message.success('¡La cotización se guardó exitósamente!')

                    // Descargar localmente la cotización
                    const quotationFileName = `Cotizacion_${BidOrder.quotation || ''}.pdf`
                    quotationDoc.save(quotationFileName)
                } catch (error) {
                    console.error('Error al generar el PDF de cotización:', error)
                    // No mostrar error al usuario, solo loguear
                }
                
                setSavingBidOrder(false)
                props.onBack(true, responseN.data.bidOrder)
            } else {
                setSavingBidOrder(false)
                message.error('Se produjo un error al guardar la cotización. Por favor, vuelva a intentarlo')
            }
        } catch (err) {
            setSavingBidOrder(false)
            message.error('Se produjo un error al guardar la cotización. Por favor, vuelva a intentarlo')
        }
    }

    return (
        <Grid className="newBidCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Nueva cotización</h2>
                </Col>
            </Row>
            <Divider/>
            <Row center="xs">
                <Col xs={12}>
                    <FormBidOrder onSubmitBidOrder={saveBidOrder}
                                isEditing={false}
                                loading={savingBidOrder}
                                clients={props.clients}
                                outsourcing={props.outsourcing}
                                companyType={props.companyType}/>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={6}>
                    <Button onClick={() => props.onBack(false, null)} disabled={savingBidOrder} loading={savingBidOrder}>
                        Salir
                    </Button>
                </Col>
            </Row>
        </Grid>
    )
}

NewBid.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(NewBid))
